module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "container_flex"
  }, [_c('navPanel'), _vm._v(" "), _c('homePageMain')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-170146d6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/App.vue
// module id = 66
// module chunks = 0